export default __webpack_public_path__ + "29306dfad3f42059e0eb6d6d4843fced.svg";